// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"0a7d612a","453":"a03b6bf4","644":"7cc000ec","667":"e024ec85","835":"de8f8adc"}[chunkId] + ".chunk.js";
};